import { ContactService } from '../services/contact.service';
import { HistoryModule } from './history/history.module';
import { NgModule } from '@angular/core';
import { LoginModule } from './login/login.module';
import { HomeModule } from './home/home.module';
import { ConditionsModule } from './conditions/conditions.module';
import { CatalogoModule } from './catalogo/catalogo.module';
import { ScoreModule } from './score/score.module';
import { CartModule } from './cart/cart.module';
import { ContactComponent } from './contact/contact.component';
import { FormsModule } from '@angular/forms';
import { ScoreService } from '../services/score.service';
import { CatalogoService } from '../services/catalogo.service';
import { CartService } from '../services/cart.service';
import { ContactModule } from './contact/contact.module';
import { RegisterModule } from './register/register.module';
import { CatalogoLudicoModule } from './catalogoludico/catalogoludico.module';
import { OutServiceModule } from './outservice/outservice.module';



@NgModule({
    imports:[
        LoginModule,
        RegisterModule,
        HomeModule,
        ConditionsModule,
        CatalogoModule,
        CatalogoLudicoModule,
        ScoreModule,
        HistoryModule,
        CartModule,
        FormsModule,
        ContactModule,
        OutServiceModule
    ],
    exports:[
        LoginModule,
        RegisterModule,
        HomeModule,
        CatalogoModule,
        CatalogoLudicoModule,
        ScoreModule,
        HistoryModule,
        CartModule,
        ContactModule,
        OutServiceModule
    ],
    providers: [ 
        ScoreService,
        CatalogoService,
        CartService,
        ContactService
    ]
})
export class PagesModule {}